const Error = () => {
    <div>
        <h1>Something Wrong</h1>
    </div>
}

export default Error;